export var lockupPeriodToDays = {
    WEEK: 7,
    MONTH: 30,
    "3MONTH": 91,
    "6MONTH": 182,
    YEAR: 365,
    "2YEAR": 365 * 2,
};
//# sourceMappingURL=lockupPeriod.js.map